<div @fadeInAnimation>
  <div class="d-flex justify-content-center tw-w-full mb-xlg">
    <div class="image">
      <img loading="lazy" src="./../../../assets/images/info.png" alt="">
    </div>
  </div>

  <div class="mb-xlg">
    <p class="text-bold text-subtitle text-center mb-xlg text-upper-case" style="font-size: 25px;">Hola {{ user ? user.name?.toLowerCase() : '' }},
      espera por favor</p>
    <p class="text-info text-center" style="font-size: 20px; line-height: 1.2;">Para poder continuar necesitamos que aceptes compartir información con
      nosotros, esto para brindarte una mejor experiencia en la plataforma.</p>
    <p class="text-info opacity-70 mb-xxs tw-w-full text-center mt-md">Datos a compartir</p>
    <p class="share-info-container">
      <span class="share-info">Nombre</span>
      <span class="share-info">Correo electrónico</span>
      <span class="share-info">Teléfono</span>
      <span class="share-info">Dirección</span>
    </p>
  </div>
</div>
